<template>
  <div>
    <v-app-bar dark color="secondary">
      <v-toolbar-title class="white--text">Activites</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn rounded icon dark @click="refreshPage">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn rounded icon dark to="/activities/new">
        <v-icon>add</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container>
      <v-card>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="items"
          :sort-by="['name']"
          :sort-desc="[false]"
          :items-per-page="-1"
          item-key="_id"
          must-sorts
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              rounded 
              icon 
              class="mr-2" 
              :to="{ name: 'Activity', params: { id: item._id } }">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              small
              rounded
              icon
              class="mr-2"
              @click="deleteItem(item._id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>


<script>
import axios from "axios";
export default {
  name: "ActivitiesList",
  data() {
    return {
      loading: true,
      headers: [
        { text: "Description", value: "description" },
        { text: "Activity", value: "name" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: [],
    };
  },
	props: [],
  methods: {
    initData() {
      this.loading = true;
      axios.get(`https://api.safetelecom.net/api/activities/`)
      .then((response) => {
        this.items = response.data;
        this.loading = false;
      });
    },
    deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
        axios
          .delete(`https://api.safetelecom.net/api/activities/${id}`)
          .then(() => {
            this.refreshPage();
          });
    },
    refreshPage() {
      this.items = [];
      this.initData();
    },
  },
  created() {
    this.initData();
  },
};
</script>
